<div class="wrapper mb-2" *ngIf="showRegisterAsReporterCard">
  <app-news-empty-banner [isFromRegisterAsReporterCard]="true" [hasReporter]="hasReporter"></app-news-empty-banner>
</div>

<ng-container *ngFor="let entry of newsEntries; let i = index">
  <news-list-item
    *ngIf="entry !== undefined;"
    [preloadFirstImage]="i < 1"
    [lazyLoadImages]="i > 0"
    [newsPost]="entry"
    (followTeamSuccess)="handleReload($event)">
  </news-list-item>
  <ng-container *ngIf="(i === 0 || (i > 0 && i % 5 === 0))">
    <lib-ad class="mb-4"></lib-ad>
  </ng-container>
  <ng-container *ngIf="(i) % 5 === 0 && randomSponsors.length > i / 5">
    <div class="mb-1">
      <app-news-sponsor-card
        [sponsor]="randomSponsors[i / 5]"
        sponsorRole="Hauptsponsor"
        class="main-sponsors"
      ></app-news-sponsor-card>
    </div>
  </ng-container>
</ng-container>
